import React from 'react';
import Dialog, { DialogHeader } from '../../../bootstrap/Dialog.jsx';
import Portal from '../../../common/Portal.jsx';
import { TableContainer } from '../../../common/Table';

// TODO: User can't actually see the reload button (even in old implementation), is it really needed?
function TaskDialog({data, columns, reloadData, ...rest}) {
    return (
        <Dialog {...rest}>
            {
                data && data.length > 0 
                ? 
                    <div className="widget-modal-body react-table-container pl-3 pr-1">
                    <TableContainer 
                        data={data} 
                        columns={columns}
                        useExpand 
                        maxColumnWidth={500}
                        maxHeight={false}
                    />
                    <button style={{display:'none'}} id='task-datagrid-reload-button' onClick={reloadData} />
                    </div>
                : <div className="widget-modal-body">{I18n.t('no_pending_task')}</div>
                }
        </Dialog>
    )
}

function WidgetModal({onClose, data, columns, reloadData}) {
    return (
        <Portal
            component={TaskDialog}
            header={<DialogHeader showBorder={true} title={I18n.t('task_list')} onClose={onClose} />}
            size = 'fw'
            closeOnOutsideClick={true}
            {...{data, columns, reloadData}}
        />
    )
}

export default WidgetModal;
